import { createContext } from 'react'

interface BreadcrumbContextType {
  registerLoading: (isLoading: boolean) => void
  loadingSections: number
}

export const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(undefined)
